import React, { useState, useEffect } from "react";
import {
    FaCalendarCheck,
    FaCalendarAlt,
    FaThumbsUp,
    FaThumbsDown,
    FaUserEdit,
    FaUserPlus,
    FaBalanceScale,
    FaArrowRight,
    FaEdit,
    FaTrashAlt,
} from "react-icons/fa";
import { fetchData, updateData } from '../../../apiService';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

const SubscriptionIndex = () => {
    const [plans, setPlans] = useState([]);
    const [errorMessageEdit, setErrorMessageEdit] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchtableData = async () => {
        const companyId = 1;
        try {
            const response = await fetchData('SubscriptionPlansApi', `/${companyId}`);
            if (response.responseCode === '1111') {
                console.log(response.response_data);
                setPlans(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Subscription Plans Details:', error);
        }
    };

    useEffect(() => {
        fetchtableData();
    }, []);

    const commonButtonStyles = {
        height: '36px',
        marginLeft: '10px',
        marginTop: '10px',
        marginRight: '8px',
    };

    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const durationOptions = [
        { label: '28 Days', value: '28' },
        { label: '168 Days', value: '168' },
        { label: 'Yearly (365 Days)', value: '365' },
    ];
    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('SubscriptionPlansApi', `/Details/${id}`);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching subscription Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();
        if (!updatedData.Name) {
            setErrorMessageEdit('Name is required !');
            setIsLoading(false);
            return;
        }
        try {
            await updateData('SubscriptionPlansApi', `${updatedData.Id}`, updatedData);
            setUpdateData({
                CompanyId: 1,
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [isHovered, setIsHovered] = useState(false);

    const baseStyles = {
        width: "100%",
        padding: "10px",
        marginTop: "15px",
        borderRadius: "8px",
        border: "1px solid #fff",
        background: loading
            ? "#fff"
            : isHovered
                ? "#c5ec7bff" // light green on hover
                : "transparent",
        color: loading
            ? "#000"
            : isHovered
                ? "#000" // text turns black on hover
                : "#fff",
        fontWeight: "bold",
        cursor: loading ? "not-allowed" : "pointer",
        transition: "all 0.3s ease",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
    };


    return (
        <div style={{ padding: "30px", fontFamily: "monospace" }}>
            <div className="flex items-center justify-between mb-4">
                <h5 className="font-bold text-green-800 text-center flex-1" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke' }}>
                    Subscription Plan
                </h5>

                <Button
                    style={{ backgroundColor: '#c5ece8ff', color: 'black', fontWeight: 'bold' }}
                    component={Link}
                    to="/SubscriptionForm"
                    onClick={() => localStorage.setItem('shouldReloadCreatePage', 'true')}
                >
                    <span>Create</span>
                </Button>
            </div>

            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "16px" }}>
                {plans.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            position: "relative",
                            borderRadius: "16px",
                            background: "#2E2E2E",
                            color: "#fff",
                            padding: "20px",
                            width: "calc(50% - 16px)",
                            maxWidth: "250px",
                            textAlign: "center",
                            boxShadow: "4px 4px 10px rgba(233, 223, 223, 0.5)",
                            cursor: "pointer",
                            transition: "transform 0.2s",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                    >
                        <FaEdit
                            onClick={() => openDetailModal(item.id)}
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                cursor: "pointer",
                                color: "#FFD700"
                            }}
                        />
                        <div style={{ fontFamily: 'monospace', fontSize: "14px", marginBottom: "10px", color: "#80ff80", fontWeight: "bold" }}>
                            {item.name}
                        </div>
                        <div style={{ fontFamily: 'monospace', fontSize: "14px", marginBottom: "5px", fontWeight: "bold" }}>
                            {item.planDuration} - days
                        </div>
                        <div style={{ fontFamily: 'monospace', fontSize: "14px", color: "#ccc", marginBottom: "10px" }}>
                            {item.description}
                        </div>
                        <div style={{ fontFamily: 'monospace', fontSize: "20px", color: "#FFD700", fontWeight: "bold" }}>
                            ₹{item.amount}
                        </div>
                    </div>
                ))}
            </div>

            {isDetailModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    {errorMessageEdit && <p className="text-red-500">{errorMessageEdit}</p>}
                    <div className="max-w-md mx-auto p-6  rounded-xl shadow-lg mt-10"
                        style={{
                            borderRadius: '10px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            backdropFilter: 'blur(10px)',
                            WebkitBackdropFilter: 'blur(10px)',
                        }}
                    >
                        <div className="flex items-center justify-between mb-4">
                            <h5 className="font-bold text-green-800 text-center flex-1" style={{ fontFamily: 'monospace', textTransform: 'uppercase', color: 'whitesmoke' }}>
                                Subscription Plan Edit
                            </h5>

                            <Button
                                style={{ ...commonButtonStyles, backgroundColor: '#ec842fff', color: 'whitesmoke' }}
                                onClick={toggleModalBranch}
                            >
                                <span>Back to list</span>
                            </Button>
                        </div>

                        <div className='m-2'>
                            <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Name</label>
                            <input
                                type="text"
                                name="Name"
                                required
                                className="w-full px-4 py-2 border rounded-md"
                                value={updatedData.Name}
                                onChange={handleUpdateInputChange}
                                style={{
                                    width: "100%",
                                    padding: "10px 10px 10px 40px",
                                    borderRadius: "8px",
                                    border: "1px solid #4c6793",
                                    background: "#2E2E2E",
                                    color: "#fff",
                                    outline: "none",
                                    transition: "border 0.3s ease",
                                }}
                            />
                        </div>

                        <div className='m-2'>
                            <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Description</label>
                            <textarea
                                name="Description"
                                rows="3"
                                required
                                className="w-full px-4 py-2 border rounded-md"
                                value={updatedData.Description}
                                onChange={handleUpdateInputChange}
                                style={{
                                    width: "100%",
                                    padding: "10px 10px 10px 40px",
                                    borderRadius: "8px",
                                    border: "1px solid #4c6793",
                                    background: "#2E2E2E",
                                    color: "#fff",
                                    outline: "none",
                                    transition: "border 0.3s ease",
                                }}
                            />
                        </div>

                        <div className='m-2'>
                            <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Amount (₹)</label>
                            <input
                                type="number"
                                name="Amount"
                                required
                                className="w-full px-4 py-2 border rounded-md"
                                value={updatedData.Amount}
                                onChange={handleUpdateInputChange}
                                style={{
                                    width: "100%",
                                    padding: "10px 10px 10px 40px",
                                    borderRadius: "8px",
                                    border: "1px solid #4c6793",
                                    background: "#2E2E2E",
                                    color: "#fff",
                                    outline: "none",
                                    transition: "border 0.3s ease",
                                }}
                            />
                        </div>

                        <div className='m-2'>
                            <label className="block text-sm font-medium text-gray-700" style={{ color: 'whitesmoke', textTransform: 'uppercase' }}>Plan Duration</label>
                            <select
                                name="PlanDuration"
                                required
                                className="w-full px-4 py-2 border rounded-md"
                                value={updatedData.PlanDuration}
                                onChange={handleUpdateInputChange}
                                style={{
                                    width: "100%",
                                    padding: "10px 10px 10px 40px",
                                    borderRadius: "8px",
                                    border: "1px solid #4c6793",
                                    background: "#2E2E2E",
                                    color: "#fff",
                                    outline: "none",
                                    transition: "border 0.3s ease",
                                }}
                            >
                                <option value="">-- Select Duration --</option>
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='m-4'>

                            <div className='m-4'>
                                <button
                                    type="submit"
                                    disabled={loading}
                                    onClick={updateRecord}
                                    onMouseEnter={() => setIsHovered(true)}
                                    onMouseLeave={() => setIsHovered(false)}
                                    style={baseStyles}
                                >
                                    Update Subscription
                                </button>

                            </div>
                        </div>

                    </div>

                </div>

            )}

        </div>
    );
};

export default SubscriptionIndex;
